import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { NAVBAR_TAB_NAMES } from "../const/navbarTabNames";

export const useGetAmSchoolTabs = () => {

    const location = useLocation()
    const { t } = useTranslation()

    return {
        [NAVBAR_TAB_NAMES.am_school_about]: {
            content: t('nav.about_programm'),
            linkTo: '/about',
        },
        [NAVBAR_TAB_NAMES.am_school_communication]: {
            content: t('nav.baccalaureate'),
            linkTo: '/communication',
        },
        [NAVBAR_TAB_NAMES.am_school_incoming]: {
            content: t('nav.incoming'),
            linkTo: '/join',
        },
        [NAVBAR_TAB_NAMES.am_school_portfolio]: {
            active: location.pathname === '/portfolio' || location.pathname.startsWith('/tag'),
            content: t('nav.portfolio'),
            linkTo: `/portfolio`,
        },
        [NAVBAR_TAB_NAMES.am_school_news]: {
            content: t('nav.news'),
            linkTo: '/news',
        },
    }
}import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { NAVBAR_TAB_NAMES } from "../const/navbarTabNames";

export const useGetAmSchoolTabs = () => {

    const location = useLocation()
    const { t } = useTranslation()

    return {
        [NAVBAR_TAB_NAMES.am_school_about]: {
            content: t('nav.about_programm'),
            linkTo: '/about',
        },
        [NAVBAR_TAB_NAMES.am_school_communication]: {
            content: t('nav.baccalaureate'),
            linkTo: '/communication',
        },
        [NAVBAR_TAB_NAMES.am_school_incoming]: {
            content: t('nav.incoming'),
            linkTo: '/join',
        },
        [NAVBAR_TAB_NAMES.am_school_portfolio]: {
            active: location.pathname === '/portfolio' || location.pathname.startsWith('/tag'),
            content: t('nav.portfolio'),
            linkTo: `/portfolio`,
        },
        [NAVBAR_TAB_NAMES.am_school_news]: {
            content: t('nav.news'),
            linkTo: '/news',
        },
    }
}